import React, {useState, useEffect} from 'react';
import {useHistory} from "react-router-dom";
import LockIcon from '@material-ui/icons/Lock';
import InputAdornment from '@material-ui/core/InputAdornment';
import {getFormData, inputChangedHandler, prepareFormData, updateObject, validateForm} from "../../shared/utility";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Alert from "@material-ui/lab/Alert";
import {makeStyles} from "@material-ui/core/styles";
import {Box, Button, TextField, IconButton, FormControl, FormControlLabel, FormGroup, Checkbox, FormHelperText} from '@material-ui/core';
import {green} from "@material-ui/core/colors";
import TermsModal from "../../components/modals/TermsModal";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import * as actions from "../../store/actions";
import {connect} from "react-redux";


const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        position: 'relative',
    },
    termsModal: {
        marginLeft: '20px',
        marginRight: '10px'
    },
    checkbox: {
        color: '#00AEEF',
    }
}));


let formData = {
    controls: {
        password: {
            label: 'New Password',
            value: '',
            validation: {
                presence: {allowEmpty: false},
                length: {minimum: 8, allowEmpty: false}
            },
            valid: false,
            touched: false,
            showPassword: false,
        },
        repassword: {
            placeholder: 'Retype New Password',
            value: '',
            validation: {
                presence: {allowEmpty: false}, 
                length: {minimum: 8, allowEmpty: false},
                equality: { attribute: "password", message: 'Passwords do not match' }
            },
            valid: false,
            touched: false,
            showPassword: false,
        },
        terms: {
            value: true,
            validation: {
                presence: {allowEmpty: false}
            },
            valid: true,
            label: 'I opt-in to Carwiser terms and conditions.',
            touched: false,
        }
    },

    loading: false,
    valid: false,
    touched: false,
    generalError: null

}

const SetPassword = (props) => {
    const classes = useStyles();
    formData = prepareFormData(formData)
    const [formState, setFormState] = useState(formData);
    const [termsModal, setTermsModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (!props.hasTemporaryPassword) {
            history.replace('/');
        }
    }, [props.hasTemporaryPassword]);

    const submitHandler = async (event) => {
        event.preventDefault();
        formData = prepareFormData(formData);
        if (validateForm(formState, setFormState)) {
            setLoading(true);
            const data = getFormData(formState)
            props.onSetPassword(props.user, data.password, (err, data) => {
                setLoading(false);
                if (err) {
                    return ;
                }
                if (props.hasTemporaryPassword) {
                    props.removeTemporaryPassword();
                }
                history.push('/');
            })
        }
    }

    const passShowedHandler = (key) => {
        const updatedState = updateObject(formState.controls);

        updatedState[key].showPassword = !updatedState[key].showPassword
        setFormState(updateObject(formState, {controls: updatedState}));
    }

    const passwordField = formState.controls.password;
    const repasswordField = formState.controls.repassword;
    const termsField = formState.controls.terms;

    return (
        <React.Fragment>
            <form className={classes.form} noValidate onSubmit={submitHandler}>
                <div>
                    <TextField
                        name={passwordField.key}
                        value={passwordField.value}
                        type={passwordField.showPassword ? 'input' : 'password'}
                        placeholder={passwordField.label}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, passwordField.key)}
                        helperText={passwordField.helperText}
                        error={!passwordField.valid && passwordField.touched}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockIcon/>
                                </InputAdornment>
                            ),
                            endAdornment: (<InputAdornment position="end">
                                <IconButton
                                    className="AdornmentIconButton"
                                    onClick={passShowedHandler.bind(this, 'password')}
                                    edge="end"
                                >
                                    {passwordField.showPassword ? <Visibility/> : <VisibilityOff/>}
                                </IconButton>
                            </InputAdornment>)
                        }}
                    />

                </div>
                <div>
                    <TextField
                        name={repasswordField.key}
                        value={repasswordField.value}
                        type={repasswordField.showPassword ? 'input' : 'password'}
                        placeholder={repasswordField.placeholder}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, repasswordField.key)}
                        helperText={repasswordField.helperText}
                        error={!repasswordField.valid && repasswordField.touched}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockIcon/>
                                </InputAdornment>
                            ),
                            endAdornment: (<InputAdornment position="end">
                                <IconButton
                                    className="AdornmentIconButton"
                                    onClick={passShowedHandler.bind(this, 'repassword')}
                                    edge="end"
                                >
                                    {repasswordField.showPassword ? <Visibility/> : <VisibilityOff/>}
                                </IconButton>
                            </InputAdornment>)
                        }}
                    />

                </div>

                {props.error &&
                <div>
                    <Alert severity="error">{props.error.message ?? ''}</Alert>
                </div>
                }


                <div className={classes.wrapper}>
                    <Button type={"submit"} fullWidth variant={"contained"} color={"primary"} size={"large"}
                            disabled={loading} className="LoginButton"> Set
                        Password</Button>
                    {loading && <CircularProgress size={24} className={classes.buttonProgress}/>}
                </div>

                <div style={{textAlign: 'left'}}>
                    <FormControl required error={termsField.helperText ? true : false} component="fieldset"
                                    className={classes.formControl}>
                        <FormGroup>
                            <FormControlLabel
                                className={classes.checkbox}
                                control={<Checkbox
                                    checked={termsField.value}
                                    onChange={() => inputChangedHandler(formState, setFormState, termsField.value ? '' : true, termsField.key)}
                                    color='default'
                                />}
                                label={<span onClick={(e) => {
                                    e.preventDefault()
                                    setTermsModal(true)
                                }} style={{fontSize: "12px"}}>I opt-in to Carwiser <u>terms and conditions</u>.</span>}
                                helpertext={termsField.helperText}
                                error={!termsField.valid && termsField.touched ? true : undefined}
                            />
                        </FormGroup>
                        <FormHelperText>{(termsField.helperText) ? 'You must accept the terms and conditions to continue' : ''}</FormHelperText>
                    </FormControl>
                </div>
            </form>

            <Box className={classes.termsModal}>
                
            </Box>
            <TermsModal open={termsModal} isLoginPage={true}
                            handleClose={() => {
                                setTermsModal(false)
                            }}/>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        hasTemporaryPassword: state.auth.hasTemporaryPassword,
        error: state.auth.error,
        user: (state.auth.user) ? state.auth.user : null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        removeTemporaryPassword: () => dispatch(actions.authRemoveTemporaryPassword()),
        onSetPassword: (user, password, cb) => dispatch(actions.changePassword(user, password, cb)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SetPassword);

